import * as React from 'react';
import { ErrorInfo } from 'react';
import { logReactError } from '../Services/Logging.Service';
import PreviewErrorPage from './PreviewErrorPage';
import { InvalidXPathError } from '@airelogic/forms';

interface IState {
  error?: Error;
}

export default class PreviewErrorBoundary extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({ error: error });

    if (error instanceof InvalidXPathError === false) {
      logReactError(error, info);
    }
  }

  render() {
    if (this.state.error) {
      return <PreviewErrorPage message={this.state.error.message} />;
    }
    return this.props.children;
  }
}
